import { Spin, Table } from 'antd'
import React from 'react'

import { EpoTableItem } from '../../common/epoTypes'
import { Rizeni } from '../../common/proceedingTypes'
import { CuzkEpoXlsxButton } from '../components/CuzkEpoXlsxButton/CuzkEpoXlsxButton'
import { Money } from '../components/Money/Money'
import { ProceedingDetailModalLink } from '../components/ProceedingDetailModalLink/ProceedingDetailModalLink'
import { TableItemsCount } from '../components/TableItemsCount/TableItemsCount'
import { TableSkeleton } from '../components/TableSkeleton/TableSkeleton'
import { parseProceedingString } from './proceedingDetailHelpers'

export const rizeniSorter = (a: EpoTableItem, b: EpoTableItem) => {
  const aRizeni = a.RIZENI
  const bRizeni = b.RIZENI
  if (aRizeni && bRizeni) {
    const maxARizeni = aRizeni.reduce(
      (max, current) =>
        current.rok && current.rok.localeCompare(max) > 0 ? current.rok : max,
      ''
    )
    const maxBRizeni = bRizeni.reduce(
      (max, current) =>
        current.rok && current.rok.localeCompare(max) > 0 ? current.rok : max,
      ''
    )
    return maxARizeni.localeCompare(maxBRizeni)
  }
  return -1
}

export const calculateSharePercentage = (record: EpoTableItem): number => {
  if (record.PODIL?.citatel && record.PODIL?.jmenovatel) {
    return (record.PODIL.citatel / (record.PODIL.jmenovatel || 1)) * 100
  } else if (record.LV) {
    return 100
  }
  return 0
}

export const podilSorter = (a: EpoTableItem, b: EpoTableItem) =>
  calculateSharePercentage(a) - calculateSharePercentage(b)

export const podilRenderer = (
  podil: EpoTableItem['PODIL'],
  record: EpoTableItem
) => {
  const percentage = calculateSharePercentage(record)
  return (
    <div>
      {podil?.citatel && podil?.jmenovatel ? (
        <>
          <span>
            {podil.citatel} / {podil.jmenovatel || 1}
          </span>
          <span className="pl-2 text-gray-400 inline-block w-20">
            <Money amount={percentage} symbol="%" />
          </span>
        </>
      ) : record.LV ? (
        <span className="pl-2 text-gray-400 inline-block w-20">
          <Money amount={percentage} symbol="%" />
        </span>
      ) : null}
    </div>
  )
}

export const rizeniRenderer = (rizeni: EpoTableItem['RIZENI']) =>
  rizeni?.map((item, index) => (
    <ProceedingDetailModalLink
      key={index}
      className="block"
      proceeding={
        parseProceedingString(
          `${item.typriz_kod}-${item.poradove_cislo}/${item.rok}-${item.prares_kod}`
        ) as Rizeni
      }
    >
      {`${item.typriz_kod}-${item.poradove_cislo}/${item.rok}`}
    </ProceedingDetailModalLink>
  ))

export const rizeniFilter = (value: string, record: EpoTableItem) =>
  !!record.RIZENI?.filter(item =>
    `${item.typriz_kod}-${item.poradove_cislo}/${item.rok}-${item.prares_kod}`
      .toLowerCase()
      .includes((value as string).toLowerCase())
  ).length

export const rowKey = (record: EpoTableItem) =>
  (record.KATUZE?.kod || '') + (record.LV || record.JPV_LV)

export const epoDetailSummary = (
  totalCount: number | undefined,
  epoId: string
) => (
  <Table.Summary.Row className="bg-[#fafafa]">
    <Table.Summary.Cell colSpan={6} index={0} className="!py-2">
      <TableItemsCount total={totalCount || 0} />
    </Table.Summary.Cell>
    <Table.Summary.Cell className="text-right !py-2" index={1}>
      <CuzkEpoXlsxButton
        buttonText="Exportovat do XLSX"
        buttonProps={{ type: 'link', ghost: false }}
        id={epoId}
      />
    </Table.Summary.Cell>
  </Table.Summary.Row>
)

export const epoDetailLocale = {
  emptyText: (
    <div className="my-8">
      <div className="mb-2 text-gray-400">
        Pro vyhledaný subjekt nebyly nalezeny v evidenci práv ČÚZK žádné
        záznamy.
      </div>
    </div>
  ),
}

export const epoDetailLoading = (
  <div className="relative flex justify-center items-center">
    <div className="w-full">
      <TableSkeleton />
    </div>
    <div className="absolute bg-white/80 text-center py-3 px-8 rounded space-y-2 border-primaryHover/70 border">
      <Spin spinning />
      <div className="text-gray-400">Načítají se data z ČÚZK...</div>
    </div>
  </div>
)
